/*
https://vuex.vuejs.org/guide/
https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
https://github.com/vuejs/vuex/tree/dev/examples
*/

import { API } from "aws-amplify";
import { getRide } from "../graphql/custom-queries";

const state = {
  ride: {},
};

const getters = {
  
};

const actions = {
  async loadRideDetails({ commit }, rideId) {
    commit("setIsLoading", true, { root: true });
    let response;
    try {
      response = await API.graphql({
        query: getRide,
        variables: {
          id: rideId,
        },
      });
    } catch (error) {
      console.error(
        `Error fetching ride details for id ${rideId}. Error: ${JSON.stringify(error)}.`
      );
      commit("setIsLoading", false, { root: true });
      return;
    }
    console.log(`Fetched ride details for id ${rideId}: ${JSON.stringify(response.data)}`);
    commit("setRide", response.data.getRide);
    commit("setIsLoading", false, { root: true });
  },
  clearStoreState({ commit }) {
    commit("clearAllState");
  },
};

const mutations = {
  setRide(state, ride) {
    state.ride = ride;
  },
  clearAllState(state) {
    state.player = {};
    state.activityPeriods = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
